import { useSeo } from "../lib/seo";
import { Link, useSearchParams } from "react-router-dom";
import type { UserRole } from "../types/vtc";
import { loginHref, parseRole, safeNext, withNext } from "../data/auth";

import AuthLayout, { AuthHeading, authLink } from "../components/auth/AuthLayout";
import DriverSignupForm from "../components/auth/DriverSignupForm";
import CompanySignupForm from "../components/auth/CompanySignupForm";
import { useT } from "../i18n";

interface SignupProps {
  /** Fixed by the route (/partners/signup); otherwise read from ?role=. */
  role?: UserRole;
}

export default function Signup({ role: fixedRole }: SignupProps) {
  const t = useT();
  const [searchParams] = useSearchParams();
  const role = fixedRole ?? parseRole(searchParams.get("role"));
  const copy = t.auth.roles[role];
  useSeo({ title: role === "company" ? t.seo.companySignup : t.seo.signup, noindex: true });
  const next = safeNext(searchParams.get("next"));

  return (
    <AuthLayout width="wide">
      {/* Driver and company signups are separate flows: no role tabs on either. */}
      <AuthHeading
        title={copy.signupTitle}
        subtitle={copy.signupSubtitle}
      />

      {/* key resets the form state when switching role */}
      {role === "driver" ? (
        <DriverSignupForm key="driver" />
      ) : (
        <CompanySignupForm key="company" />
      )}

      <p className="mt-6 mb-0 border-t border-line pt-5 text-center text-sm text-muted">
        {t.auth.signup.haveAccount}{" "}
        <Link to={withNext(loginHref(role), next)} className={`font-medium ${authLink}`}>
          {t.common.login}
        </Link>
      </p>
    </AuthLayout>
  );
}
